import React, { ChangeEvent, ReactNode } from 'react';

import { CmFormControl, CmFormLabel, CmSelect } from '@/components/uiParts';

interface Props {
  fontWeight?: 'bold' | 'normal';
  color?: string;
  isRequired?: boolean;
  isInvalid?: boolean;
  bg?: string;
  placeholder?: string;
  id?: string;
  label: string;
  value?: string | number;
  width?: string;
  selectWidth?: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  children: ReactNode;
  error?: ReactNode;
}

export const CmLabelAndSelect: React.FC<Props> = ({
  fontWeight,
  isRequired = false,
  isInvalid = false,
  bg,
  children,
  placeholder,
  color,
  id = '',
  label,
  value = '',
  width = '100%',
  selectWidth = '100%',
  onChange,
  error,
}) => {
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabel htmlFor={id} {...{ isRequired, fontWeight }}>
        {label}
      </CmFormLabel>
      <CmSelect
        width={selectWidth}
        {...{ bg, id, value, onChange, color, placeholder }}
      >
        {children}
      </CmSelect>
      {error}
    </CmFormControl>
  );
};
